import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material';

export const MuiCustomLoadingButton = styled(LoadingButton, {
  shouldForwardProp: (prop: string) => !['isShow', 'isLoadingBtn'].includes(prop),
})(({ theme }) => ({
  '& .MuiCircularProgress-root': {
    width: '20px !important',
    height: '20px !important',
  },
  '&.MuiButton-sizeSmall': {
    '& .MuiCircularProgress-root': {
      width: '16px !important',
      height: '16px !important',
    },
  },
  '&.Mui-disabled': {
    pointerEvents: 'initial',
    color: theme.palette.case.neutral.n0,
    backgroundColor: theme.palette.case.neutral.n400,
  },
}));
